import { IonContent } from '@ionic/react';
import React from 'react';

import { S3_BUCKET_URL } from '@/constants.ts';
import { webCampaign } from '@/modules/webCampaign';
import { LogoWithAppName } from '@/pages/Onboarding/components/LogoWithAppName';
import { PrideStepLoading } from '@/pages/Onboarding/components/PrideStepLoading';
import { useOnboarding } from '@/pages/Onboarding/context';

import { PageStyles, PageTitleStyles } from './WelcomeScreen.styles';

export const WelcomeScreen: React.FC = () => {
  const data = webCampaign.getLayoutNotes();

  const { wizard } = useOnboarding();

  const handleNextStep = () => {
    wizard.nextStep();
  };

  const getBackgroundSrc = () => {
    if (!data || data.length === 0)
      return `/assets/layout-own-ai-man-roleplay/s1.png`;

    const note = data[0];

    return `${S3_BUCKET_URL}/layout-own-ai-man-roleplay/first-screen/${note}.png`;
  };

  return (
    <PageStyles background="dark-forest" backgroundSrc={getBackgroundSrc()}>
      <IonContent>
        <div className="content-wrapper">
          <LogoWithAppName className="app-logo" withCaption={false} />

          <PageTitleStyles
            className="page-title"
            component="h1"
            variant="headline-large"
            align="center"
          >
            Start your romantic
            <br />
            <PageTitleStyles
              variant="inherit"
              color="white"
              component="span"
              className="page-subtitle"
            >
              journey now
            </PageTitleStyles>
          </PageTitleStyles>

          <div className="loading-wrapper">
            <PrideStepLoading
              duration={3.5}
              onComplete={() => handleNextStep()}
            />
          </div>
        </div>
      </IonContent>
    </PageStyles>
  );
};
